/**
 * Filter for the Numerals tab's "Bind to claim term" list.
 *
 * ``analysis.key_terms`` is not rewritten when a claim is steered, and
 * dependents carry copies of their parent's terms, so the raw list
 * offers terms the claim no longer recites. Quantities ("at least
 * 250 ms") also land in key_terms but are not elements a numeral can
 * point at.
 *
 * Kept out of ``ReferencePanel.tsx`` so the unit tests can exercise it
 * without the component's store / API imports.
 */

const QUANTITY_ONLY_RE =
  /^(?:(?:at\s+(?:least|most)|less\s+than|more\s+than|greater\s+than|up\s+to|about|approximately|between)\s+)?[<>≤≥~]?\s*\d+(?:[.,]\d+)?\s*(?:%|°\s*[a-z]?|[a-zµ]+(?:\s*\/\s*[a-z]+)?)?(?:\s+(?:and|to)\s+\d+(?:[.,]\d+)?\s*[a-zµ%]*)?$/i;

function normalise(s: string): string {
  return s.toLowerCase().replace(/\s+/g, ' ').trim();
}

/** True when ``term`` appears in the claim's current text and is not
 *  just a quantity. */
export function isBindableClaimTerm(term: string, claimText: string): boolean {
  const t = normalise(term);
  if (!t) return false;
  if (QUANTITY_ONLY_RE.test(t)) return false;
  return normalise(claimText || '').includes(t);
}
